import React, {useEffect, useState} from "react";
import t, {changeLanguage} from "../../../components/I18N/TranslateHelpers";
import {
  GetCurrentLocale, isResponsive, isSmartphone,
} from "../../../components/Utils";
import ProductsRelated from "../../Products/ProductsRelated";
import WishlistProducts from "./WishlistProducts";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../app/RootReducer";
import OrdersPage from "./OrdersPage";
import {SpinnerOnTop} from "../../../components/SpinnerOnTop";
import MultiStepsForm from "./MultiStepsForm";
import {useLocation} from "react-router-dom";
import AddressesPage from "../Address/AddressesPage";
import {getUserAccount} from "../UsersSlice";

const ProfilePage = () => {
  const locale = GetCurrentLocale();
  changeLanguage(locale)

  const dispatch= useDispatch();

  const isAuthenticated = useSelector((state: RootState) => state.userRdc.isAuthenticated);
  const userAccount = useSelector((state: RootState) => state.userRdc.userDetail?.customer);
  console.log(userAccount)
  const isRequesting = useSelector((state:RootState) => state.userRdc.isRequesting)
  const userAddresses = useSelector((state: RootState) => state.userRdc.userAddresses)
  const isRequestingAssociatedProduct = useSelector((state: RootState) => state.productBySlugRdc.isRequestingProductsAssociated);
  const suggestedProducts = userAccount ? userAccount.suggestedProducts : null
  const productRelated = () => {
    return(
      <aside className="col-lg-12 mt-5">
        <ProductsRelated associatedProduct={suggestedProducts} isRequestingAssociatedProduct={isRequestingAssociatedProduct}/>
      </aside>
    )
  }
  useEffect(() => {
    if(isAuthenticated){
      dispatch(getUserAccount(false,false));
    }
  }, []);

  const allTabs = [
    {
      name: t('my_profile'),
      id:"tab_profile"
    },{
      name: t('my_addresses'),
      id:"tab_addresses"
    },
    {
      name: t('my_orders'),
      id:"tab_orders"
    },
    {
      name: t('wishlist'),
      id:"tab_whishlist"
    }
    ]
  const menuTabsProfile = () => {
    return(
      allTabs.map((tabItem, index) =>
        <li className="nav-item" key={tabItem.name}>
          <a href="#" data-bs-target={"#" + tabItem.id} data-bs-toggle="tab" className={activeTab !== tabItem.id ? "nav-link" : "nav-link active"} onClick={() => handleTabChange(tabItem.id)}>
            {tabItem.name}
          </a>
        </li>
      )
    )
  }

  // mise à jour l'URL avec l'ID de l'onglet sélectionné
  const updateUrlWithTabId = (tabId: string) => {
    const params = new URLSearchParams(window.location.search);
    params.set('tab', tabId);
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.pushState({ path: newUrl }, '', newUrl);
  };


  //ouvrir la tab via les paramètres URL
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(allTabs[0].id);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabId = params.get('tab');
    if (!tabId) {
      updateUrlWithTabId(allTabs[0].id);
    }else{
      setActiveTab(tabId)
    }
  }, [location.search]);
  const handleTabChange = (tabId: any) => {
    updateUrlWithTabId(tabId);
  };


  return (
    isAuthenticated ?
      <div className="pdt-60 pdb-120 border-top bg-circle profilepage-container">
          <div className="row pb-5 mx-5">
            <aside className="col-lg-3 menu-profile-tabs">
              <div className="card">
                <div className="card-body">
                  <header className="card-header tabs-sidebar">
                    <ul className="nav nav-tabs card-header-tabs">
                      {
                        menuTabsProfile()
                      }
                    </ul>
                  </header>
                </div>
              </div>
              {
                !isResponsive && !isSmartphone ?
                  productRelated()
                : null
              }
            </aside>
            <div className="col-lg-9 profile-tabs">
              <div className="card">
                <div className="tab-content">
                  <article id={allTabs[0].id}
                           className={`tab-pane card-body ${activeTab === allTabs[0].id ? 'show active' : ''}`}>
                    <h5 className="my-0">{t('my_profile')}</h5>
                    <hr/>
                    {
                      !isRequesting && userAccount && userAddresses ?
                        <MultiStepsForm
                          isCreateAccount={false}
                          isEditForm={true}
                          isCartPage={false}
                          activeStep={0}
                          remarkText={null}
                          setRemarqueText={undefined}
                          selectedServices={null}
                          setSelectedServices={undefined}
                        />
                        : <SpinnerOnTop/>
                    }
                    <hr/>
                    <div className="row">
                      <div className="col-md">
                        <article className="box mb-3 bg-light">
                          <a className="btn float-end btn-light btn-sm"
                             href={"/" + locale + t('url_forgot_mdp')}>{t('cahnge')}</a>
                          <p className="title mb-0">{t('password')}</p>
                          <small className="text-muted d-block">{t('change_password_here')}</small>
                        </article>
                      </div>
                    </div>
                  </article>
                  <article id={allTabs[1].id}
                           className={`tab-pane card-body ${activeTab === allTabs[1].id ? 'show active' : ''}`}>
                    <h5 className="my-0">{t('my_addresses')}</h5>
                    <hr/>
                    <AddressesPage/>
                  </article>

                  <article id={allTabs[2].id}
                           className={`tab-pane card-body ${activeTab === allTabs[2].id ? 'show active' : ''}`}>
                    <h5 className="my-0">{t('my_orders')}</h5>
                    <hr/>
                    <OrdersPage/>
                  </article>

                  <article id={allTabs[3].id}
                           className={`tab-pane card-body ${activeTab === allTabs[3].id ? 'show active' : ''}`}>
                    <h5 className="my-0">{t('wishlist')}</h5>
                    <hr/>
                    <WishlistProducts/>
                  </article>
                </div>
              </div>

            </div>
            {
              isResponsive || isSmartphone ?
                productRelated()
                : null
            }
          </div>
      </div>
      :
      <div className="card-body text-center">
        <h4 className="py-3">{t('connect_for_page') }</h4>
        <a href={ "/" + locale + t('url_login')} className="btn btn-primary mr-5">
          {t('login')}
        </a>
        <a href={ "/" + locale + t('url_create_account')} className="btn btn-primary">
          {t('create_account')}
        </a>
      </div>
  )
}

export default ProfilePage;
